import { render, staticRenderFns } from "./CreateContact.vue?vue&type=template&id=64b979bb&scoped=true"
import script from "./CreateContact.vue?vue&type=script&lang=js"
export * from "./CreateContact.vue?vue&type=script&lang=js"
import style0 from "./CreateContact.vue?vue&type=style&index=0&id=64b979bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b979bb",
  null
  
)

export default component.exports